import WatersFilterMain from "../waters_filter_main.js";
import WaterList from "./water_list.js";
import WatersFilterAside from "./filter_aside.js";
import Pagination from '../../../components/filter_desktop/pagination.js.jsx';
import CampListLoading from '../../../components/filter_desktop/camp_list_loading.js';

export default class WatersFilterDesktop extends WatersFilterMain {
  constructor(props) {
    super(props);
    this.emptyOutput = this.emptyOutput.bind(this);
  }

  emptyOutput () {
    return(
      <div className='search-none' style={{alignItems: "flex-start"}}>
        <div className="search-none__grid">
          <div className='icon search-icon_img'></div>
          <div>
            <h5>К сожалению, ни один объект не найден.</h5>
            <p className='search-none__grid__text text_gray'>Попробуйте отменить часть фильтров</p>
            <div className="filter-tags-list">
              <div className='filter-search-none__btn'>
                <button className='filter-search-none__btn__text'
                        onClick={this.resetFilter}
                >
                  Сбросить всё
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    let waterList = undefined;

    if (!this.isFiltered) {
      waterList = <CampListLoading camps_count={this.pageSize} />;
    } else if (this.getPage().length > 0) {
      waterList =
        <div>
          <WaterList waters={this.getPage()}
                     filter_params={this.props.filter_params}
                     filters={this.state.filters} />

          <Pagination pageCount={this.totalPages()}
                      pageNum={this.state.pageNum}
                      setPage={this.setPageNum} />
        </div>
    } else {
      waterList = this.emptyOutput();
    }

    let filterOutput = undefined;
      filterOutput =
        <div>
          {waterList}
        </div>
    return (
      <div className="row">
        <div className="col-3">
          <div>
            <WatersFilterAside data={this.props.filter_params}
                         filters={this.state.filters}
                         filter={this.filter}
                         resetPageNum={this.resetPageNum} />
          </div>
        </div>

        <div className="col-9">
          {filterOutput}
        </div>
      </div>
    )
  }
}
